var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.4 36.6",
    style: {
      enableBackground: "new 0 0 121.4 36.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#DD4C6A;}\n\t.st2{fill:#DD6B7C;}\n\t.st3{fill:url(#SVGID_00000160182170759711401010000005874433203072463756_);}\n\t.st4{fill:url(#SVGID_00000099658890010617823800000008123437665772734643_);}\n\t.st5{fill:url(#SVGID_00000113311805351175448270000009312165692583921795_);}\n\t.st6{fill:#4E1B3D;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{opacity:0.6;fill:#D177B8;enable-background:new    ;}\n\t.st9{fill:url(#SVGID_00000091727801691558458210000012428503389196581031_);}\n\t.st10{fill:url(#SVGID_00000173133245900553553090000013879679430236866484_);}\n\t.st11{fill:url(#SVGID_00000160882266676627172390000017261546535426217602_);}\n\t.st12{fill:url(#SVGID_00000111889616690716856170000014667209427508457088_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.1623,
    y1: -0.4001,
    x2: 103.1623,
    y2: 32.2067,
    gradientTransform: "matrix(1 0 0 -1 0 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.9,33.5c0.8,3.1,20.7,4.8,28.9-1.7c8.8-7,9.5-24.7-2.2-27.7S80.2,11.1,85.9,33.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.4,20.5c0,0,3-18.3,17.5-20.3c12.9-1.8,16.9,10,16.9,10S100-11.5,85.4,20.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.1,30.5c0,0,2.6,3.5,4.2,4.9c0,0-3.7-0.3-4.2-1.4C84.7,33,85.1,30.5,85.1,30.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.1,36.2c0,0,13.2,1,20.4-6.4c6.3-6.5,5.9-12.3,5.9-12.3s1.3,7.9-6.2,14.4C107.7,38.4,95.1,36.2,95.1,36.2z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073686202441818294120000012380981560816183471_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.4,
    y1: 6.19,
    x2: 101.4,
    y2: 30.39,
    gradientTransform: "matrix(1 0 0 -1 0 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ACA1DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A518A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000073686202441818294120000012380981560816183471_)"
    },
    cx: 101.4,
    cy: 17.6,
    r: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114072833251140837820000012692453107421466017_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.4,
    y1: 6.89,
    x2: 101.4,
    y2: 29.6572,
    gradientTransform: "matrix(1 0 0 -1 0 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BAA9CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    style: {
      stopColor: "#404577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000114072833251140837820000012692453107421466017_)"
    },
    cx: 101.4,
    cy: 17.6,
    r: 11.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008135049694104005280000010959471588831605430_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.4,
    y1: 10.8705,
    x2: 101.4,
    y2: 25.6429,
    gradientTransform: "matrix(1 0 0 -1 0 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#1B0023"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000008135049694104005280000010959471588831605430_)"
    },
    cx: 101.4,
    cy: 17.6,
    r: 7.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M84.9,26c0,0,0.3-15.5,16.2-20s19.8,7.2,19.8,7.2S122,2.6,109.4,1.9C93.9,1,84.7,15.6,84.9,26z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M109.5,16c-0.7,0.6,2.6,0.8,5.1-0.2c2.2-0.9,3.3-2.3,3.1-2.5C117.5,13.1,112.4,13.5,109.5,16z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M107.7,16.7c-0.9-0.3-2,0.2-2.1,0.7s1.1,1.1,1.7,0.9C107.8,18,108.2,16.8,107.7,16.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85,28.4c0,0,3.2-16,17.9-19.1s18.1,4.6,18.1,4.6l-0.2-0.7c0,0-1.6-10.4-18.4-8.8S84.4,24.6,85,28.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083069375906812286230000010103209791213311650_",
    gradientUnits: "userSpaceOnUse",
    x1: -1304.6443,
    y1: -0.4001,
    x2: -1304.6443,
    y2: 32.2166,
    gradientTransform: "matrix(-1 0 0 -1 -1286.4028 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEE2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    style: {
      stopColor: "#BDC9FB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083069375906812286230000010103209791213311650_)"
    },
    d: "M35.5,33.5c-0.8,3.1-20.7,4.8-28.9-1.7 c-8.8-7-9.5-24.7,2.2-27.7C20.7,1.3,41.2,11.1,35.5,33.5z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36,20.5c0,0-3-18.3-17.5-20.3c-12.9-1.8-16.9,10-16.9,10S21.4-11.5,36,20.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.3,30.5c0,0-2.6,3.5-4.2,4.9c0,0,3.7-0.3,4.2-1.4C36.7,33,36.3,30.5,36.3,30.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M26.3,36.2c0,0-13.2,1-20.4-6.4C-0.4,23.3,0,17.5,0,17.5s-1.3,7.9,6.2,14.4S26.3,36.2,26.3,36.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067214491055097944760000005367515476445393570_",
    gradientUnits: "userSpaceOnUse",
    x1: -1306.4028,
    y1: 6.19,
    x2: -1306.4028,
    y2: 30.39,
    gradientTransform: "matrix(-1 0 0 -1 -1286.4028 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ACA1DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6A518A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000067214491055097944760000005367515476445393570_)"
    },
    cx: 20,
    cy: 17.6,
    r: 12.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171681571552729423230000007713598202174544269_",
    gradientUnits: "userSpaceOnUse",
    x1: -1306.4028,
    y1: 6.89,
    x2: -1306.4028,
    y2: 29.6572,
    gradientTransform: "matrix(-1 0 0 -1 -1286.4028 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BAA9CC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9637,
    style: {
      stopColor: "#404577"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000171681571552729423230000007713598202174544269_)"
    },
    cx: 20,
    cy: 17.6,
    r: 11.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158025757835081143620000006496824914844958127_",
    gradientUnits: "userSpaceOnUse",
    x1: -1306.4028,
    y1: 10.8705,
    x2: -1306.4028,
    y2: 25.6429,
    gradientTransform: "matrix(-1 0 0 -1 -1286.4028 35.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88629B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#1B0023"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000158025757835081143620000006496824914844958127_)"
    },
    cx: 20,
    cy: 17.6,
    r: 7.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.5,26c0,0-0.3-15.5-16.2-20C4.5,1.5,0.5,13.2,0.5,13.2S-0.6,2.6,12,1.9C27.5,1,36.7,15.6,36.5,26z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M11.9,16c0.7,0.6-2.6,0.8-5.1-0.2c-2.2-0.9-3.3-2.3-3.1-2.5C3.9,13.1,9,13.5,11.9,16z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.7,16.7c0.9-0.3,2,0.2,2.1,0.7c0,0.5-1.1,1.1-1.7,0.9C13.6,18,13.2,16.8,13.7,16.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.4,28.4c0,0-3.2-16-17.9-19.1S0.4,13.9,0.4,13.9l0.2-0.7c0,0,1.6-10.4,18.4-8.8C35.9,6,37,24.6,36.4,28.4z "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes1);
export default __webpack_public_path__ + "static/media/Eyes1.505948a73abb2f051a9a1f621252c5b1.svg";
export { ForwardRef as ReactComponent };